import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaStar, FaTimes } from 'react-icons/fa';
import { getAllBanks, setDefaultBank } from '../services/api.service';
import Loading from '../components/loading';
import Helper from '../services/helper.service';

const BankListPage = () => {
  const [banks, setBanks] = useState([]);
  const [search, setSearch] = useState('');
  const [filteredBanks, setFilteredBanks] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchBanks();
  }, []);

  const fetchBanks = async () => {
    setLoading(true);

    try {
      const res = await getAllBanks();
      console.log(res);

      setBanks(res);
      setFilteredBanks(res);

    } catch {
      Helper.toast("Erreur lors du chargement des banques", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setFilteredBanks(
      banks.filter((bank) =>
        bank.name?.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [search, banks]);

  const handleSetDefault = async (bankId) => {
    try {
      await setDefaultBank(bankId);
      fetchBanks();

    } catch {
      Helper.toast("Erreur lors de la mise à jour de la banque par défaut", "error");
    }
  };

  return (
    <section className="max-w-7xl mx-auto p-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Gestion des banques</h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
        <div className="relative w-full sm:max-w-sm">
          <input
            type="text"
            placeholder="Rechercher une banque"
            className="w-full border border-gray-300 p-2 pr-10 rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {search && (
            <button
              onClick={() => setSearch('')}
              className="absolute right-3 top-3 text-gray-500 text-lg"
            >
              <FaTimes className="w-4 h-4" />
            </button>
          )}
        </div>

        <button
          onClick={() => navigate('/bank/new')}
          className="bg-primary hover:bg-blue-700 text-white px-4 py-2 rounded shadow"
        >
          Ajouter une banque
        </button>
      </div>

      {/* Bank List */}
      {loading ? (
        <div className="flex justify-center py-24">
          <Loading />
        </div>
      ) : filteredBanks.length > 0 ? (
        <div className="grid grid-cols-1 gap-4">
          {filteredBanks.map((bank) => (
            <div
              key={bank._id}
              className="bg-white border rounded-lg p-4 shadow hover:shadow-md transition flex justify-between items-start"
            >
              <div>
                <h3 className="font-semibold text-lg text-gray-800">{bank.name}</h3>
                <p className="text-sm text-gray-500 mt-1">{bank.description}</p>
              </div>

              <div className="flex flex-col gap-2 items-end">
                <button
                  onClick={() => navigate(`/bank/${bank._id}`)}
                  className="bg-gray-100 hover:bg-gray-200 text-gray-800 text-sm py-2 px-3 rounded shadow-sm"
                >
                  Modifier
                </button>
                <button
                  onClick={() => handleSetDefault(bank._id)}
                  className="flex items-center gap-2 text-sm group"
                >
                  <FaStar
                    className={`w-4 h-4 transition-colors ${bank.useByDefault ? 'text-yellow-500' : 'text-gray-400 group-hover:text-yellow-400'
                      }`}
                  />
                  <span className={bank.useByDefault ? 'text-gray-900 font-medium' : 'text-gray-600 group-hover:text-gray-800'}>
                    {bank.useByDefault ? 'Par défaut' : 'Définir par défaut'}
                  </span>
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-500 mt-10">
          Aucune banque trouvée.
        </p>
      )}
    </section>
  );
};

export default BankListPage;